export default "__VITE_ASSET__a444bb5d__"